webpackJsonp([259915366324434],{

/***/ 993:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0017_foxs_den_students.jpg","type":"Ultimate Spell","subtype":"Summon","cost":4,"ATK":null,"HP":null,"rules_text_1":"Summon four 1/1 white Ninja tokens. This turn, your Ninja units have haste and stealth.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Fox's Den Students","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"White","spec":"Ninjutsu","bottom":"Ultimate Magic","rulings":[],"keywords":["Haste","Stealth"],"slug":"foxs_den_students"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"foxs_den_students","keywords":["Haste","Stealth"],"imageRegex":"/foxs_den_students.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-foxs-den-students-564b0d2d3097aa72b203.js